
import {apiIndustryDel, apiIndustryLists} from "@/api/IndustryRequests";
import {apiNewsShopLists} from '@/api/shop'
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import LsDialog from "@/components/ls-dialog.vue";
import {RequestPaging} from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import {apiOtherLists} from "@/api/order";

@Component({
  components: {
    lsPagination,
    ExportData,
    LsDialog,
    DatePicker,
  },
})
export default class ShopList extends Vue {
  /** S Data **/

  apiShopLists = apiIndustryLists;

  pager: RequestPaging = new RequestPaging();
  shopData: any[] = []
  searchObj = {
    sid: "",
    cumulative: "",
    goods: "",
    buyer: "",
    tel: "",
  };
  otherLists: any = {
    set_meal: [],
    pay_status: [],
    pay_way: [],
  };

  /** E Data **/
  //获取商场列表数据
  async getShopListsFn(): Promise<void> {
    const res: any = await apiNewsShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.data;
  }

  /** S Methods **/
  // 获取订单其他 方式数据
  getOtherMethodList() {
    apiOtherLists().then((res: any) => {
      this.otherLists = res;
    });
  }

  // 获取行业视频列表
  getShopLists(): void {
    this.pager.request({
      callback: apiIndustryLists,
      params: {
        ...this.searchObj,
        type: 4,
      },
    });
  }

  // 修改行业视频状态
  async shopSwitchStatusEdit(status: number, id: number): Promise<void> {
    // await apiShopSwitchStatus({ id });
    this.getShopLists();
  }

  async changeRemarks(text: string, id: number): Promise<void> {
    // await apiChangeRemark({ id: id, remark: text });
    this.getShopLists();
  }

  // 删除行业视频
  async onShopDelete(row: any): Promise<void> {
    await apiIndustryDel({id: row.id});
    this.getShopLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists();
  }


  // 去编辑行业视频
  toShopEdit(id: number | any): void {
    this.$router.push({
      path: "/IndustryPromotion/lists_detail",
      query: {
        id: id,
      },
    });
  }


  // 去商家后台
  toShop(url: any, status: number) {
    if (status == 0) return this.$message.error("该行业视频暂未营业中");

    if (url.indexOf("https://") === 0) window.open(url);
    else if (url.indexOf("http://") === 0) window.open(url);
    else window.open("http://" + url);
  }

  /** E Methods **/

  /** S ods **/
  created() {
    this.getShopLists();
    this.getOtherMethodList();

    // 获取商城列表是数据
    this.getShopListsFn()
  }
}
